export function getBasePath() {
  // 現在のパスから言語部分を除いてベースパスを取得
  const currentPath = window.location.pathname;
  const basePathMatch = currentPath.match(/^(\/natadera\/)/);
  
  if (basePathMatch) {
    return basePathMatch[1];
  }
  
  return "/natadera/";
}
